module.exports = __webpack_public_path__ + "img/silent-opus.005fda1a.png";